import React from "react";

const AuthErrorPage = ({ error, onRetry }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8f9fa",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "white",
          borderRadius: "8px",
          padding: "60px 40px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          maxWidth: "500px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: "48px",
            marginBottom: "20px",
            color: "#e74c3c",
          }}
        >
          ⚠️
        </div>
        <h1
          style={{
            margin: "0 0 15px 0",
            fontSize: "24px",
            color: "#333",
            fontWeight: "600",
          }}
        >
          Authentication Error
        </h1>
        <p
          style={{
            margin: "0 0 30px 0",
            fontSize: "14px",
            color: "#666",
            lineHeight: "1.6",
          }}
        >
          We encountered an issue during the authentication process. Please try
          logging in again or contact support if the problem persists.
        </p>
        <div
          style={{
            backgroundColor: "#ecf0f1",
            padding: "15px",
            borderRadius: "4px",
            marginBottom: "30px",
            fontSize: "12px",
            color: "#555",
            wordBreak: "break-word",
          }}
        >
          <strong>Error details:</strong>
          <div style={{ marginTop: "8px" }}>{error?.message || "Unknown error"}</div>
        </div>
        <div
          style={{
            display: "flex",
            gap: "15px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {onRetry && (
            <button
              onClick={onRetry}
              style={{
                padding: "10px 20px",
                backgroundColor: "#27ae60",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#229954")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#27ae60")}
            >
              Try Again
            </button>
          )}
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              backgroundColor: "#3498db",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#2980b9")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#3498db")}
          >
            Refresh Page
          </button>
          <a
            href="mailto:support@fluentco.com"
            style={{
              padding: "10px 20px",
              backgroundColor: "#ecf0f1",
              color: "#333",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              textDecoration: "none",
              display: "inline-block",
            }}
            onMouseOver={(e) => (e.target.style.backgroundColor = "#d5dbdb")}
            onMouseOut={(e) => (e.target.style.backgroundColor = "#ecf0f1")}
          >
            Contact Support
          </a>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorPage;
